<template>
	<div class="correction-wrap pt-sm-8 pt-6">
		<h1 class="report--title mb-2">
			{{ $t('report.card.monthly-report.title') }}
		</h1>
		<h2 class="report--text white-space-pre mb-6">
			{{ $t('report.card.monthly-report.sub-title') }}
		</h2>
		<div
			class="white py-5 px-0 pa-sm-3 mx-auto"
			:style="`width: ${userDevice === 'mobile' ? 225 : 266}px;height: ${
				userDevice === 'mobile' ? 274 : 310
			}px; `"
			style="
				overflow: hidden;
				border-top-left-radius: 20px;
				border-top-right-radius: 20px;
				box-shadow: 11px 17px 28px 0 rgba(33, 51, 82, 0.14);
			"
		>
			<v-img
				:src="require(`@/assets/images/monthly-report-example-${language}.png`)"
				alt=""
			/>
		</div>
		<!-- <v-row no-gutters>
			<v-col cols="6">
				<div class="white-blue-box box mb-2">
					<p class="text">한 달간 사용한 단어</p>
					<p class="title">941개</p>
				</div>
			</v-col>
			<v-col cols="6"
				><div class="blue-box box mb-2">
					<p class="text">수업 당 단어량</p>
					<p class="title">235개</p>
				</div></v-col
			>
			<v-col cols="6"
				><div class="white-blue-box box">
					<p class="text">한 달간 영작한 문장</p>
					<p class="title">99개</p>
				</div></v-col
			>
			<v-col cols="6"
				><div class="blue-box box">
					<p class="text">수업 당 영작한 문장</p>
					<p class="title">25개</p>
				</div></v-col
			>
		</v-row> -->
	</div>
</template>

<script>
export default {
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.correction-wrap {
	margin: 0 auto;
	width: 396px;
	height: 470px;
	border-radius: 20px;
	background-color: #f1f5ff;
}

@media screen and (max-width: 600px) {
	.correction-wrap {
		width: 100%;
		height: 425px;
	}
}

.report--title {
	font-size: 22px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
	color: #1a1a1a;
}
.report--text {
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.8px;
	text-align: center;
	color: #1a1a1a;
}

.box {
	padding: 10px 1px 10px 10px;
	border-radius: 4.8px;

	.text {
		font-size: 9.6px;
		font-weight: 600;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.86;
		letter-spacing: -0.3px;
		margin-bottom: 0;
	}
	.title {
		font-size: 11.2px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 1;
		letter-spacing: -0.35px;
		color: #191f28;
		margin-bottom: 0;
	}
}
.white-blue-box {
	margin-right: 4px;
	background-color: #ebf4ff;
	.text {
		color: #0080f6;
	}
	.title {
		color: #191f28;
	}
}
.blue-box {
	margin-left: 4px;
	background-color: #0080f6;
	.text {
		color: #fff;
	}
	.title {
		color: #fff;
	}
}
</style>
